module.exports = __webpack_public_path__ + "img/5.68b5c39f.png";